var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-bar"},[_c('input',{ref:"search-input",attrs:{"type":"text"},domProps:{"value":_vm.city},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.keyPress()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }